<template>
  <div class="toggle-section creation-read-page">
    <div class="container mt-5">
      <!--Section: Content-->
      <section class="formation mb-5">
        <!-- Section heading -->
        <h2 class="text-center font-weight-bold">
          Formations VTC pour {{ town.town }}
        </h2>
        <!-- Section description -->
        <div class="mx-auto w-responsive mb-5">
          <div class="container mb-5">
            <!--Section: Content-->
            <section class="text-center formation__pricing">
              <!-- Section heading -->
              <p
                class="text-center argument font-weight-bold dark-grey-text pb-2 my-4"
              >
                <strong>Prix formations vtc pour {{ town.town }}</strong>
              </p>
              <!-- Section description -->
              <p class="text-center w-responsive mx-auto mb-5">
                Découvrez nos <strong>formations VTC</strong>, conçues pour vous
                former aux exigences spécifiques du métier de
                <strong>chauffeur VTC</strong> et vous aider à exceller dans ce
                domaine en plein essor.
              </p>

              <ServicePricingGrid
                eyebrow="Formation VTC"
                :offers="pricingOffers"
              />
            </section>
            <!--Section: Content-->
          </div>
        </div>
        <div class="hr-d"></div>
        <CallToContact
          title="Contactez nous"
          subTitle="L'equipe pédagogique de l'institut taxi s'occupe de vos démarches administratives."
        />
        <!-- Grid row -->
      </section>
      <!--Section: Content-->
    </div>
    <section class="container-fluid double-block">
      <div class="double-block__title">
        <h2><span class="brand-pseudo">ITTI</span><br />Ecole VTC</h2>
      </div>
      <div class="dark-grey-text double-block__articles">
        <div class="row align-items-center article">
          <div class="col-lg-5 text-center slide-left">
            <div
              class="view overlay text-center rounded z-depth-2 mb-lg-0 mb-4"
            >
              <img
                src="@/assets/pictures/vtc-course.webp"
                alt="a-car-in-paris"
                class="img-fluid"
                loading="lazy"
              />
            </div>
          </div>
          <div class="col-lg-7 slide-right">
            <h2 class="mb-3">
              {{ town.town }} Formations VTC :<br />
              Un tremplin vers une carrière polyvalente et passionnante
            </h2>
            <p>
              Découvrez notre Institut Taxi, votre partenaire de confiance pour
              des formations de qualité dans le domaine du <strong>VTC</strong>.
              Nous vous proposons une
              <strong>formation vtc initiale</strong> complète qui vous
              permettra d'acquérir les compétences essentielles pour
              <strong>devenir un chauffeur VTC</strong> professionnel et
              accompli. Notre programme couvre divers aspects tels que la
              réglementation, la sécurité routière, les techniques de conduite
              défensive, la gestion des itinéraires, ainsi que les notions
              fondamentales du service client. Vous serez formé par des
              professionnels expérimentés qui vous guideront tout au long du
              processus d'apprentissage et vous prépareront efficacement pour
              les examens pratiques et théoriques. De plus, nos
              <strong>formations vtc</strong> sont éligibles au CPF, ce qui
              signifie que vous pourrez les suivre gratuitement et sans frais
              supplémentaires.
            </p>
          </div>
        </div>
        <div class="hr-d"></div>
        <div class="row align-items-center mb-5 article__left">
          <div class="col-lg-5 order-lg-2 slide-right text-center">
            <div
              class="view overlay text-center rounded z-depth-2 mb-lg-0 mb-4"
            >
              <img
                src="@/assets/pictures/sunny.webp"
                alt="rising-sun"
                class="img-fluid"
                loading="lazy"
              />
            </div>
          </div>
          <div class="col-lg-7 order-lg-1 slide-left">
            <h2 class="mb-3">
              {{ town.town }} Devenir VTC :<br />
              Accélérés et Cours du Soir
            </h2>
            <p>
              Chez Institut Taxi, nous comprenons que vous avez peut-être des
              contraintes de temps et que vous souhaitez obtenir rapidement
              votre <strong>carte professionnelle VTC</strong>. C'est pourquoi
              nous proposons des <strong>cours accélérés</strong> qui vous
              permettent d'acquérir toutes les compétences nécessaires dans un
              laps de temps réduit. Ces formations intensives vous offrent la
              possibilité d'obtenir <strong>votre carte VTC</strong> plus
              rapidement, tout en bénéficiant d'un enseignement de qualité. Par
              ailleurs, si vous avez des engagements professionnels ou
              personnels en journée, nos cours du soir sont conçus pour
              s'adapter à votre emploi du temps chargé. Vous pourrez ainsi
              suivre la formation à des horaires flexibles, tout en poursuivant
              vos autres activités. De plus, nous acceptons le CPF pour
              <strong>votre formation vtc</strong> et proposons un paiement
              échelonné en 3 fois sans frais pour faciliter l'accès à nos
              formations. Que vous souhaitez faire une
              <strong
                >reconversion professionnelle en tant que chauffeur VTC</strong
              >
              ou que vous souhaitiez élargir vos compétences, l'Institut Taxi
              est là pour vous accompagner tout au long de votre parcours de
              <strong>formation en tant que VTC.</strong>
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
  <!---------------------------seperation------------------------------------------------>
  <HomeService />
  <!-----------------------section------------------------------------------------------->
  <div class="toggle-section">
    <section class="container-fluid double-block">
      <div class="double-block__title">
        <h2>
          <span class="brand-pseudo">ITTI</span><br />Nos Formations pour VTC de
          {{ town.town }}
        </h2>
      </div>
      <div class="dark-grey-text double-block__articles">
        <div class="row align-items-center article">
          <div class="col-lg-5 slide-left text-center">
            <div
              class="view overlay text-center rounded z-depth-2 mb-lg-0 mb-4"
            >
              <img
                src="@/assets/pictures/itti-front.webp"
                alt="the school vtc outside viaw"
                class="img-fluid"
                loading="lazy"
              />
            </div>
          </div>
          <div class="col-lg-7 slide-right">
            <h2 class="mb-3">
              Formations initiale VTC pour {{ town.town }} :<br />
              Une Formation de Qualité
            </h2>
            <p>
              À l'Institut Taxi, nous nous adressons particulièrement à ceux qui
              débutent leur carrière de <strong>chauffeur VTC</strong>, à ceux
              en reconversion professionnelle, et à tous ceux qui souhaitent
              <strong>devenir VTC à {{ town.town }}</strong
              >. Nos
              <strong>formations VTC sont éligibles au financement CPF</strong>,
              ce qui permet à nos stagiaires de bénéficier d'une
              <strong>formation VTC gratuite</strong>. Nous offrons une grande
              flexibilité avec des options pour une
              <strong>formation VTC accélérée</strong> en soirée, le week-end,
              ainsi que des programmes plus longs pour ceux qui préfèrent un
              apprentissage progressif. En cas d'échec à l'<strong
                >examen VTC</strong
              >, vous êtes les bienvenus pour recommencer la formation avec une
              nouvelle session, où seuls les frais d'examen seront à votre
              charge. Notre accompagnement inclut un accompagnement pour obtenir
              votre <strong>carte professionnelle VTC</strong>, des conseils sur
              le choix de <strong>votre véhicule VTC</strong>, et une
              <strong>formation continue</strong> pour améliorer vos compétences
              et renouveler votre <strong>carte pro VTC</strong>. Dans votre
              parcours pour <strong>devenir VTC</strong> L'institut taxi vous
              offre un soutien administratif pour vous guider à chaque étape de
              votre parcours professionnel et vous permettre de vous concentrer
              à 100% sur votre <strong>carrière VTC</strong>.L'Institut Taxi
              vous accompagne vers la réussite de votre
              <strong>formation VTC</strong>.
            </p>
          </div>
        </div>
        <div class="hr-d"></div>
        <div class="row align-items-center article__left">
          <div class="col-lg-5 order-lg-2 slide-right text-center">
            <div
              class="view overlay text-center rounded z-depth-2 mb-lg-0 mb-4"
            >
              <img
                src="@/assets/pictures/room-out.webp"
                alt="class room vtc formation"
                class="img-fluid"
                loading="lazy"
              />
            </div>
          </div>
          <div class="col-lg-7 order-lg-1 slide-left">
            <h2 class="mb-3">
              Renouvellement carte pro VTC pour {{ town.town }} :<br />
              Formation Continue VTC
            </h2>
            <p>
              La <strong>formation continue VTC</strong> est cruciale pour
              maintenir à jour les compétences et se conformer aux exigences
              réglementaires du secteur du transport de personnes. Obligatoire
              pour tous les chauffeurs
              <strong>VTC à {{ town.town }}</strong> titulaires d'une carte
              professionnelle. La <strong>formation VTC continue</strong> dure
              14 heures, renouvelable tous les cinq ans, elle permet de rester
              informé des dernières réglementations et des évolutions du secteur
              <strong>vtc a {{ town.town }}</strong
              >. En suivant cette <strong>formation VTC continue</strong>, les
              chauffeurs peuvent actualiser leurs connaissances en matière de
              réglementation spécifique aux <strong>VTC</strong>. La
              <strong>formation continue VTC</strong> comprend quatre modules
              indispensables pour le renouvellement de la
              <strong>carte professionnelle VTC</strong>. Chaque module de la
              <strong>formation VTC continue</strong> dure 3h30 et couvre des
              domaines essentiels. Le module sur le droit du transport public
              particulier de personnes vous permet de comprendre les
              réglementations légales en vigueur. Le module de réglementation
              spécifique liée à l’activité de
              <strong>vtc à {{ town.town }}</strong> fournit des informations
              cruciales pour distinguer les exigences et les pratiques des
              <strong>VTC</strong> par rapport aux Taxi. La sécurité routière
              est un autre aspect fondamental, où vous apprendrez les meilleures
              pratiques pour assurer la sécurité de vos passagers et de
              vous-même. Enfin, le module d'anglais est conçu pour améliorer vos
              compétences linguistiques, facilitant ainsi la communication avec
              une clientèle internationale. Ces modules sont conçus pour offrir
              une mise à jour complète et approfondie des connaissances
              nécessaires pour exceller en tant que
              <strong>chauffeur VTC à {{ town.town }}</strong
              >.
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { formatDate } from "@/assets/globalJs/global.js";
import { useMeta } from "vue-meta";
import { toRef, watchEffect } from "vue";
import HomeService from "@/components/home/HomeService.vue";
import ServicePricingGrid from "@/components/services/ServicePricingGrid.vue";

const pricingOffers = [
  {
    id: "creation-vtc-initiale",
    title: "INITIALE",
    price: "1350",
    route: "/formation-vtc-initiale",
    variant: "primary",
    meta: [
      { label: "Volume", value: "90H / 3 semaines" },
      { label: "Planning", value: "Lundi au Vendredi" },
      { label: "Horaires", value: "9h30-12h30 / 13h30-16h30" },
    ],
    highlights: [
      "Éligible CPF",
      "Paiement en 3x sans frais",
      "3 séances de conduite",
      "Véhicule mis à disposition le jour de l'examen",
    ],
    rawDescription:
      "90H / 3 semaines. Lundi au Vendredi. 9h30-12h30 13h30-16h30. Éligible CPF. Paiement en 3x sans frais. 3 séances de conduite. Véhicule mis à disposition le jour de l'examen.",
  },
  {
    id: "creation-vtc-initiale-soir",
    title: "INITIALE-soir",
    badge: "Soir",
    price: "1350",
    route: "/formation-vtc-initiale",
    variant: "primary",
    meta: [
      { label: "Volume", value: "60H / 4 semaines" },
      { label: "Planning", value: "Lundi au Vendredi" },
      { label: "Horaires", value: "18h00 / 21h00" },
    ],
    highlights: [
      "Éligible CPF",
      "Paiement en 3x sans frais",
      "3 séances de conduite",
      "Véhicule mis à disposition le jour de l'examen",
    ],
    rawDescription:
      "60H / 4 semaines. Lundi au Vendredi. 18h00 21h00. Éligible CPF. Paiement en 3x sans frais. 3 séances de conduite. Véhicule mis à disposition le jour de l'examen.",
  },
  {
    id: "creation-vtc-initiale-accelere",
    title: "INITIALE-accéléré",
    badge: "Accéléré",
    price: "1350",
    route: "/formation-vtc-initiale",
    variant: "primary",
    meta: [
      { label: "Volume", value: "15H / 1 semaines" },
      { label: "Planning", value: "Lundi au Vendredi" },
      { label: "Horaires", value: "18h00 / 21h00" },
    ],
    highlights: [
      "Éligible CPF",
      "Paiement en 3x sans frais",
      "3 séances de conduite",
      "Véhicule mis à disposition le jour de l'examen",
    ],
    rawDescription:
      "15H / 1 semaines. Lundi au Vendredi. 18h00 21h00. Éligible CPF. Paiement en 3x sans frais. 3 séances de conduite. Véhicule mis à disposition le jour de l'examen.",
  },
  {
    id: "creation-vtc-continue",
    title: "CONTINUE",
    badge: "14h",
    price: "170",
    route: "/formation-vtc-continue",
    variant: "light",
    meta: [
      { label: "Volume", value: "14h / 2 jours" },
      { label: "Planning", value: "Disponibilté à convenir" },
    ],
    rawDescription: "14h / 2 jours. Disponibilté à convenir.",
  },
  {
    id: "creation-vtc-pratique-seule",
    title: "PRATIQUE SEULE",
    badge: "Conduite",
    price: "390",
    route: "/formation-vtc-pratique-seule",
    variant: "light",
    meta: [
      { label: "Accompagnement", value: "3 séances de conduite" },
      {
        label: "Examen",
        value: "Véhicule mis à disposition le jour de l'examen",
      },
    ],
    rawDescription:
      "3 séances de conduite. Véhicule mis à disposition le jour de l'examen.",
  },
];

const SITE_URL = "https://www.institut-taxi.fr";

function townSlug(input) {
  return input.toLowerCase().replace(/\s+/g, "-");
}

function buildTownPricingJsonLd(town) {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: `Prix formations vtc pour ${town.town}`,
    description: `Tarifs des formations VTC proposées par l'Institut Taxi pour ${town.town}.`,
    itemListOrder: "https://schema.org/ItemListOrderAscending",
    numberOfItems: pricingOffers.length,
    itemListElement: pricingOffers.map((offer, index) => ({
      "@type": "ListItem",
      position: index + 1,
      item: {
        "@type": "Service",
        name: `${offer.title} VTC à ${town.town}`,
        serviceType: "Formation VTC",
        provider: {
          "@type": "Organization",
          name: "Institut Taxi",
          url: SITE_URL,
        },
        areaServed: town.town,
        url: `${SITE_URL}${offer.route}`,
        description: `Formation VTC à ${town.town}. ${offer.rawDescription}`,
        offers: {
          "@type": "Offer",
          priceCurrency: "EUR",
          price: offer.price,
          url: `${SITE_URL}${offer.route}`,
          availability: "https://schema.org/InStock",
        },
      },
    })),
  };
}

export default {
  components: { HomeService, ServicePricingGrid },
  name: "CreationRead",
  props: {
    town: {
      type: Object,
      required: true,
    },
    backgroundImage: String,
  },
  setup(props) {
    const townProp = toRef(props, "town");

    watchEffect(() => {
      if (townProp.value) {
        const sentenceBegin = "Devenir chauffeur VTC à ";
        const sentenceEnd =
          " et découvrez notre formation initiale VTC complète pour devenir un chauffeur de vtc professionnel qualifié. Apprenez les compétences essentielles en matière de réglementation, de sécurité routière, de gestion et de service client.";

        const metaDescription =
          sentenceBegin + townProp.value.content + sentenceEnd;

        const townValue = townProp.value.town;
        const slugTown = townSlug(townValue);
        const canonical = `${SITE_URL}/devenir-vtc/${slugTown}/${townProp.value.id}`;
        const jsonLd = buildTownPricingJsonLd(townProp.value);

        useMeta({
          title: "Devenir VTC à " + townValue,
          meta: [
            {
              name: "description",
              content: metaDescription,
            },
          ],
          link: [
            {
              rel: "canonical",
              href: canonical,
            },
          ],
          script: [
            {
              type: "application/ld+json",
              json: jsonLd,
            },
          ],
        });
      }
    });

    return {
      townData: townProp, // Utiliser un nom unique pour la clé retournée
      pricingOffers,
    };
  },
  mounted() {
    import("@/assets/globalJs/global.js").then((module) => {
      const { observeElements } = module;
      observeElements(".slide-right", ".slide-left", ".fall");
    });
  },
  computed: {
    formattedDate() {
      return formatDate(this.town.updatedAt);
    },
    hasBackgroundImage() {
      return this.backgroundImage !== undefined;
    },
    ...mapGetters({
      Towns: "StateTowns",
      User: "StateUser",
      Town: "StateTown",
    }),
  },
  methods: {
    scrollTo(sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        window.scrollTo({
          top: section.offsetTop,
          behavior: "smooth", // Défilement fluide
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.creation-read-page {
  padding-top: 0;
}

.toggle-section {
  display: block;
}

.formation {
  margin-bottom: clamp(74px, 8vw, 110px);

  & h2 {
    width: min(100%, 1100px);
    margin: 0 auto clamp(34px, 4vw, 48px);
    text-align: center;
    background-color: $color-primary;
    color: $color-secondary;
    padding: clamp(18px, 2.4vw, 24px) clamp(18px, 4vw, 34px);
    border-radius: 28px;
    font-family: "Spartan", "Arial Black", Arial, sans-serif;
    font-weight: 700;
    font-size: clamp(1.34rem, 1rem + 0.96vw, 2.1rem);
    line-height: 1.02;
    letter-spacing: 0.03em;
    box-shadow: 0 18px 36px rgba(0, 42, 84, 0.14);
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.08);
  }

  & > .mx-auto {
    width: 100%;
    max-width: none;
  }

  & > .mx-auto > .container {
    width: min(100%, 1180px);
    padding: 0;
  }
}

.formation__pricing {
  & .argument {
    margin: 0 0 18px !important;
    font-family: "Spartan", "Arial Black", Arial, sans-serif;
    font-weight: 700;
    font-size: clamp(1.26rem, 1.08rem + 0.56vw, 1.74rem);
    color: $color-primary !important;
  }

  & > p:last-of-type {
    width: min(100%, 760px);
    margin: 0 auto 40px !important;
    color: $color-text;
    font-family: "Roboto", "Helvetica Neue", Arial, sans-serif;
    font-size: clamp(1rem, 0.94rem + 0.24vw, 1.08rem);
    line-height: 1.72;
  }

  :deep(.pricing-grid) {
    margin-top: 8px;
  }
}

.hr-d {
  width: 92px;
  height: 4px;
  margin: 36px auto 42px;
  border-radius: 999px;
  background: $color-secondary;
  box-shadow: 0 10px 22px rgba(254, 185, 20, 0.18);
}

.double-block {
  padding: clamp(74px, 9vw, 108px) 20px clamp(92px, 11vw, 126px);

  @media screen and (min-width: 768px) {
    padding-inline: 28px;
  }

  @media screen and (min-width: 992px) {
    padding: clamp(88px, 9vw, 116px) clamp(28px, 4vw, 56px)
      clamp(110px, 10vw, 138px);
  }

  &__title {
    width: min(100%, 1040px);
    text-align: center;
    margin: 0 auto 44px;

    & h2 {
      margin: 0;
      font-family: "Spartan", "Arial Black", Arial, sans-serif;
      font-weight: 700;
      color: $color-primary;
      font-size: clamp(1.56rem, 1.18rem + 0.98vw, 2.3rem);
      line-height: 1.02;
      letter-spacing: 0.03em;
      text-shadow: 0 1px 0 rgba(255, 255, 255, 0.88),
        0 14px 28px rgba(0, 42, 84, 0.08);
    }

    @media screen and (min-width: 992px) {
      margin-bottom: 56px;
    }
  }

  &__articles {
    width: min(100%, 1180px);
    margin: 0 auto;

    > .hr-d {
      margin: 8px auto 12px;
    }

    .article,
    .article__left {
      row-gap: 24px;
      margin: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
}

.double-block__articles .col-lg-5,
.double-block__articles .col-lg-7,
.double-block__articles .order-lg-1,
.double-block__articles .order-lg-2 {
  flex: 0 0 100%;
  width: 100%;
  max-width: 100%;
}

.double-block__articles .col-lg-5 .view.overlay {
  margin: 0 !important;
  padding: clamp(10px, 1vw, 12px);
  border-radius: 28px !important;
  background: #ffffff;
  box-shadow: 0 18px 38px rgba(0, 42, 84, 0.12),
    inset 0 0 0 1px rgba(0, 42, 84, 0.08);
  overflow: hidden;
  width: min(100%, 860px);
  margin-inline: auto !important;
}

.double-block__articles .col-lg-5 img {
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  border-radius: 22px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.12);
}

.double-block__articles .col-lg-7 {
  position: relative;
  width: min(100%, 860px);
  margin: 0 auto;
  padding: clamp(24px, 3.2vw, 34px);
  border-radius: 30px;
  box-shadow: 0 22px 48px rgba(0, 42, 84, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);

  &::before {
    content: "";
    display: block;
    width: 56px;
    height: 4px;
    margin-bottom: 18px;
    border-radius: 999px;
    background: $color-secondary;
    box-shadow: 0 8px 18px rgba(254, 185, 20, 0.18);
  }

  & h2 {
    margin: 0 0 14px !important;
    font-family: "Spartan", "Arial Black", Arial, sans-serif;
    font-weight: 700;
    font-size: clamp(1.28rem, 1.08rem + 0.72vw, 1.92rem);
    line-height: 1.05;
    color: $color-primary;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.88),
      0 10px 24px rgba(0, 42, 84, 0.08);
  }

  & p {
    margin: 0;
    font-family: "Roboto", "Helvetica Neue", Arial, sans-serif;
    font-size: clamp(1rem, 0.95rem + 0.28vw, 1.08rem);
    line-height: 1.76;
    color: $color-text;
  }

  & strong {
    color: $color-primary;
    font-weight: 700;
  }
}

.double-block__articles .article > .col-lg-7 {
  background: rgba(254, 185, 20, 0.14);
  box-shadow: inset 0 0 0 1px rgba(254, 185, 20, 0.22),
    0 22px 48px rgba(0, 42, 84, 0.08);
}

.double-block__articles .article__left > .col-lg-7 {
  background: rgba(0, 42, 84, 0.06);
  box-shadow: inset 0 0 0 1px rgba(0, 42, 84, 0.12),
    0 22px 48px rgba(0, 42, 84, 0.08);

  &::before {
    background: $color-primary;
    box-shadow: 0 8px 18px rgba(0, 42, 84, 0.16);
  }
}

.brand-pseudo {
  display: inline-block;
  margin-bottom: 10px;
  font-family: "adam";
  font-size: 0.72rem;
  letter-spacing: 0.34em;
  text-transform: uppercase;
  color: $color-secondary;
  text-shadow: none;
}

.slide-right.active {
  @include slide-right(1.2s);
}

.slide-left.active {
  @include slide-left(1.2s);
}

.fall.active {
  @include fall-down(1s);
}

@media screen and (max-width: 991px) {
  .double-block__articles .col-lg-7 {
    margin-top: 8px;
  }
}

@media screen and (max-width: 767px) {
  header .item {
    padding-block: 72px 44px;
  }

  .header-content {
    padding: 24px 22px 26px;
    border-radius: 28px;

    & .line {
      left: 22px;
      top: 20px;
      width: 78px;
    }
  }

  .formation {
    margin-bottom: 72px;

    & h2 {
      padding: 18px 16px;
      border-radius: 24px;
    }
  }

  .formation__pricing > p:last-of-type {
    margin-bottom: 30px !important;
  }

  .pricing-card {
    border-radius: 28px;
  }

  .pricing-card__top {
    padding: 22px 20px 10px !important;
  }

  .pricing-card__body {
    padding: 0 20px 20px !important;
  }

  .pricing-card__list li {
    padding: 13px 14px;
  }

  .double-block {
    padding: 70px 16px 88px;
  }

  .double-block__articles .col-lg-7 {
    padding: 22px 20px;
    border-radius: 26px;
  }
}
</style>
